import React from "react";

// A simple, beautiful donut chart using SVG
export function DonutChart({ segments, total, size = 180, stroke = 18, centerLabel, centerValue }) {
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const sum = total ?? segments.reduce((s, x) => s + (x.value || 0), 0);
  let offset = 0;
  return (
    <div className="flex items-center gap-6">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="-rotate-90">
        <circle
          cx={size / 2} cy={size / 2} r={radius}
          fill="none" stroke="hsl(var(--surface-hover))" strokeWidth={stroke}
        />
        {sum > 0 && segments.map((seg, i) => {
          if (!seg.value) return null;
          const frac = seg.value / sum;
          const len = frac * circumference;
          const dash = `${len} ${circumference - len}`;
          const dashOffset = -offset;
          offset += len;
          return (
            <circle
              key={i}
              cx={size / 2} cy={size / 2} r={radius}
              fill="none" stroke={seg.color} strokeWidth={stroke}
              strokeDasharray={dash} strokeDashoffset={dashOffset}
              strokeLinecap="butt"
            />
          );
        })}
        <g transform={`translate(${size / 2} ${size / 2}) rotate(90)`}>
          {centerValue !== undefined && (
            <text textAnchor="middle" y="-2" className="font-mono" style={{ fontSize: size * 0.19, fontWeight: 700, fill: "hsl(var(--text))" }}>
              {centerValue}
            </text>
          )}
          {centerLabel && (
            <text textAnchor="middle" y={size * 0.13} style={{ fontSize: size * 0.07, fill: "hsl(var(--text-muted))", textTransform: "uppercase", letterSpacing: "0.15em", fontWeight: 600 }}>
              {centerLabel}
            </text>
          )}
        </g>
      </svg>
      <div className="space-y-2">
        {segments.map((s, i) => (
          <div key={i} className="flex items-center gap-2 text-[12px]">
            <span className="w-2.5 h-2.5 rounded-full" style={{ background: s.color }} />
            <span className="text-[hsl(var(--text-muted))]">{s.label}</span>
            <span className="font-mono font-semibold text-[hsl(var(--text))] ml-auto">{s.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
